import { render, staticRenderFns } from "./StatRow.vue?vue&type=template&id=327d46b8&"
import script from "./StatRow.vue?vue&type=script&lang=js&"
export * from "./StatRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports